(() => {
  if (window.mingenioFichaPdfTracking) return;
  window.mingenioFichaPdfTracking = true;
  const shopify = window.Shopify;
  if (shopify && !shopify.customerPrivacy && typeof shopify.loadFeatures === 'function') {
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || (event.button !== undefined && event.button !== 0)) return;
    const link = event.target.closest?.('a[data-mingenio-ficha-pdf]');
    if (!link) return;
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy || privacy.analyticsProcessingAllowed() !== true) return;
      if (!Array.isArray(window.dataLayer)) return;
      const url = new URL(link.href, location.origin);
      if (!/\.pdf$/i.test(url.pathname)) return;
      const parameters = {
        send_to: 'G-HJYHCNF5NR',
        product_id: link.dataset.productId,
        product_handle: link.dataset.productHandle,
        file_extension: 'pdf',
        file_name: url.pathname.split('/').pop().slice(0, 100),
        link_url: url.origin + url.pathname,
        page_location: location.origin + location.pathname,
        interaction_type: 'pdf_open_intent'
      };
      if (window.Shopify?.theme?.role !== 'main') parameters.debug_mode = true;
      function send() { window.dataLayer.push(arguments); }
      send('event', 'ficha_tecnica_click', parameters);
    } catch (_) {}
  });
})();
